import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Card, CardBody, Col, Row, Input, Alert, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, Button, Modal, ModalHeader, ModalBody, ModalFooter, Label } from 'reactstrap';
import axios from 'axios';
import api, { handleApiError } from '../../../helpers/api';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import FeatherIcon from 'feather-icons-react';
import DeleteModal from '../../../Components/Common/DeleteModal';
import parse from 'html-react-parser';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Dropzone from 'react-dropzone';
import { useTranslation } from 'react-i18next';
import { useDispatch } from "react-redux";

const customStyles = `
.card {
  transition: transform 0.3s ease;
  max-width: 300px;
  width: 100%;
}
.card:hover {
  transform: translateY(-5px);
}
.filter-container {
  display: flex;
  flex-direction: row;
  gap: 1rem;
  align-items: center;
  flex-wrap: nowrap;
  overflow-x: auto;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
}
.form-select {
  max-width: fit-content;
}
.filter-container .form-control,
.filter-container .form-select {
  border-radius: 4px;
  border: 1px solid #ced4da;
  min-width: 140px;
  font-size: 0.9rem;
  padding: 0.5rem 1rem;
}
.filter-container .form-control:focus,
.filter-container .form-select:focus {
  border-color: #0ab39c;
  box-shadow: 0 0 0 0.2rem rgba(10, 179, 156, 0.25);
}
.action-btn {
  font-size: 0.85rem;
  padding: 0.4rem 0.8rem;
  transition: background-color 0.3s ease, transform 0.2s ease;
}
.action-btn:hover {
  transform: translateY(-2px);
}
.dropdown-menu {
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  border: none;
}
.dropdown-item {
  font-size: 0.85rem;
  padding: 0.5rem 1rem;
  color: #2a4966;
}
.dropdown-item:hover {
  background-color: #f1f5f7;
  color: #0ab39c;
}
.dropdown-item i {
  margin-right: 0.5rem;
}
.avatar-sm {
  width: 2.5rem;
  height: 2.5rem;
  line-height: 2.5rem;
  font-size: 1rem;
}
.pagination-separated .page-link {
  border-radius: 4px;
  margin: 0 0.2rem;
}
.pagination-separated .page-item.active .page-link {
  background-color: #0ab39c;
  border-color: #0ab39c;
}
.text-wrap {
  white-space: normal;
  word-break: break-word;
  max-width: 100%;
}
.inscription-btn {
  font-size: 0.85rem;
  padding: 0.4rem 0.8rem;
  background-color: #0ab39c;
  border-color: #0ab39c;
}
.inscription-btn:hover {
  background-color: #099885;
  border-color: #099885;
}
.course-image {
  width: 100%;
  height: 120px;
  object-fit: cover;
  border-radius: 4px;
}
.video-preview {
  font-size: 0.85rem;
  color: #0ab39c;
  cursor: pointer;
}
.video-preview:hover {
  color: #099885;
  text-decoration: underline;
}
.truncate-text {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.modal-video {
  width: 100%;
  max-height: 400px;
}
.udemy-modal .modal-content {
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}
.udemy-modal .modal-header {
  background-color: #f7f7f7;
  border-bottom: none;
}
.udemy-modal .modal-body {
  padding: 2rem;
}
.udemy-modal .course-details {
  display: flex;
  gap: 2rem;
}
.udemy-modal .description-section {
  flex: 1;
  max-height: 300px;
  overflow-y: auto;
}
.udemy-modal .video-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.udemy-modal .video-section video {
  width: 100%;
  max-height: 200px;
  border-radius: 4px;
}
.udemy-modal .meta-info {
  font-size: 0.9rem;
  color: #555;
}
.udemy-modal .dropzone {
  border: 2px dashed #0ab39c;
  border-radius: 4px;
  padding: 1rem;
  text-align: center;
  transition: background-color 0.3s ease;
}
.udemy-modal .dropzone:hover {
  background-color: #f1f5f7;
}
.udemy-modal .form-control {
  border-radius: 4px;
  border: 1px solid #ced4da;
}
.udemy-modal .form-control:focus {
  border-color: #0ab39c;
  box-shadow: 0 0 0 0.2rem rgba(10, 179, 156, 0.25);
}
.udemy-modal .ck-editor__editable {
  min-height: 150px;
  border-radius: 4px;
  border: 1px solid #ced4da;
}
.udemy-modal .ck-editor__editable:focus {
  border-color: #0ab39c;
  box-shadow: 0 0 0 0.2rem rgba(10, 179, 156, 0.25);
}
.udemy-modal .btn-primary {
  background-color: #0ab39c;
  border-color: #0ab39c;
}
.udemy-modal .btn-primary:hover {
  background-color: #099885;
  border-color: #099885;
}
.udemy-modal .btn-danger {
  background-color: #f06548;
  border-color: #f06548;
}
.udemy-modal .btn-danger:hover {
  background-color: #e55a3e;
  border-color: #e55a3e;
}
@media (max-width: 768px) {
  .filter-container {
    flex-wrap: nowrap;
    overflow-x: auto;
  }
  .filter-container .form-control,
  .filter-container .form-select {
    min-width: 120px;
    font-size: 0.85rem;
  }
  .card {
    max-width: 100%;
  }
  .udemy-modal .course-details {
    flex-direction: column;
  }
}
`;

const ListCourses = () => {
    const { t } = useTranslation();
    const [courses, setCourses] = useState([]);
    const [filteredCourses, setFilteredCourses] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [deleteModal, setDeleteModal] = useState(false);
    const [videoModal, setVideoModal] = useState(false);
    const [overviewModal, setOverviewModal] = useState(false);
    const [updateModal, setUpdateModal] = useState(false);
    const [visibilityModal, setVisibilityModal] = useState(false);
    const [visibility, setVisibility] = useState('on');
    const [visibilityLoading, setVisibilityLoading] = useState(false);
    const [selectedCourse, setSelectedCourse] = useState(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        titre: '',
        description: '',
        lienZoom: '',
        duree: '',
    });
    const [selectedImage, setSelectedImage] = useState([]);
    const [selectedVideo, setSelectedVideo] = useState([]);
    const [deleteOldImage, setDeleteOldImage] = useState(false);
    const [deleteOldVideo, setDeleteOldVideo] = useState(false);
    const [updateError, setUpdateError] = useState(null);
    const [updateLoading, setUpdateLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [sortField, setSortField] = useState('createdAt');
    const [sortOrder, setSortOrder] = useState('desc');
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 8;

    const fetchCourses = useCallback(async () => {
        try {
            setIsLoading(true);
            const response = await api.get('/formation', {
                withCredentials: true,
            });
            console.log('response.data', response.data);
            setCourses(response.data.data || []);
            setFilteredCourses(response.data.data || []);
            setIsLoading(false);
        } catch (err) {
            if (err.response.data?.status === 401 || err.response.data?.status === 403) {
                await handleApiError(err, dispatch, navigate);
            } else {
                setError(t('list_courses.error_fetch'));
                setIsLoading(false);
                toast.error(t('list_courses.error_fetch'));
            }
        }
    }, [t, dispatch, navigate]);

    const fetchVisibility = useCallback(async () => {
        try {
            const response = await api.get('/formation/visibility', {
                withCredentials: true,
            });
            setVisibility(response.data.visibility || 'on');
        } catch (error) {
            console.error('Error fetching visibility:', error);
            toast.error(t('list_courses.error_fetch_visibility'));
        }
    }, [t]);

    useEffect(() => {
        fetchCourses();
        fetchVisibility();
    }, [fetchCourses, fetchVisibility]);

    const handleToggleVisibility = async () => {
        try {
            setVisibilityLoading(true);
            const response = await api.post('/formation/visibility', {}, {
                withCredentials: true,
            });
            console.log('Visibility toggled:', response);
            setVisibility(response.data.visibility);
            toast.success(t('list_courses.success_toggle_visibility'));
            setVisibilityModal(false);
        } catch (error) {
            console.error('Error toggling visibility:', error);
            toast.error(t('list_courses.error_toggle_visibility'));
        } finally {
            setVisibilityLoading(false);
        }
    };

    // Filter and Sort Courses
    useEffect(() => {
        let updatedCourses = [...courses];
        if (searchQuery) {
            updatedCourses = updatedCourses.filter(
                course =>
                    (course.titre?.toLowerCase().includes(searchQuery.toLowerCase()) || '') ||
                    (course.description?.toLowerCase().includes(searchQuery.toLowerCase()) || '')
            );
        }
        updatedCourses.sort((a, b) => {
            if (sortField === 'inscriptionCount') {
                return sortOrder === 'desc'
                    ? b.inscriptionCount - a.inscriptionCount
                    : a.inscriptionCount - b.inscriptionCount;
            } else if (sortField === 'duree') {
                return sortOrder === 'desc'
                    ? (b.duree || 0) - (a.duree || 0)
                    : (a.duree || 0) - (b.duree || 0);
            } else {
                const dateA = new Date(a.createdAt || Date.now());
                const dateB = new Date(b.createdAt || Date.now());
                return sortOrder === 'desc' ? dateB - dateA : dateA - dateB;
            }
        });
        setFilteredCourses(updatedCourses);
    }, [courses, searchQuery, sortField, sortOrder]);

    // Handle Delete
    const handleDeleteCourse = async () => {
        try {
            await api.delete(`/formation/${selectedCourse._id}`, {
                withCredentials: true,
            });
            toast.success(t('list_courses.success_delete'));
            setDeleteModal(false);
            fetchCourses();
        } catch (err) {
            if (err.response.data?.status === 401 || err.response.data?.status === 403) {
                await handleApiError(err, dispatch, navigate);
            } else {
                toast.error(t('list_courses.error_delete'));
            }
        }
    };

    // Handle Delete Click
    const handleDeleteClick = (course) => {
        setSelectedCourse(course);
        setDeleteModal(true);
    };

    // Handle Video Preview
    const handleVideoPreview = (course) => {
        setSelectedCourse(course);
        setVideoModal(true);
    };

    // Handle Course Overview
    const handleOverview = (course) => {
        setSelectedCourse(course);
        setOverviewModal(true);
    };

    // Handle Update Modal
    const handleUpdate = (course) => {
        setSelectedCourse(course);
        setFormData({
            titre: course.titre || '',
            description: course.description || '',
            lienZoom: course.lienZoom || '',
            duree: course.duree || '',
        });
        setSelectedImage(
            course.imageUrl
                ? [{ preview: course.imageUrl, name: 'Current Image', formattedSize: 'Existing' }]
                : []
        );
        setSelectedVideo(
            course.previewVideoUrl
                ? [{ preview: course.previewVideoUrl, name: 'Current Video', formattedSize: 'Existing' }]
                : []
        );
        setDeleteOldImage(false);
        setDeleteOldVideo(false);
        setUpdateError(null);
        setUpdateLoading(false);
        setUpdateModal(true);
    };

    // Handle Update Form
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleDescriptionChange = (event, editor) => {
        setFormData(prev => ({ ...prev, description: editor.getData() }));
    };

    const handleImageAccepted = (files) => {
        const file = files[0];
        if (file) {
            Object.assign(file, {
                preview: URL.createObjectURL(file),
                formattedSize: formatBytes(file.size),
            });
            setSelectedImage([file]);
            setDeleteOldImage(true);
        }
    };

    const handleVideoAccepted = (files) => {
        const file = files[0];
        if (file) {
            Object.assign(file, {
                preview: URL.createObjectURL(file),
                formattedSize: formatBytes(file.size),
            });
            setSelectedVideo([file]);
            setDeleteOldVideo(true);
        }
    };

    const formatBytes = (bytes, decimals = 2) => {
        if (bytes === 0) return "0 Bytes";
        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    };

    const handleUpdateSubmit = async () => {
        if (!formData.titre) {
            setUpdateError(t("list_courses.error_update_title"));
            toast.error(t("list_courses.error_update_title"));
            return;
        }
        if (formData.duree && (isNaN(formData.duree) || Number(formData.duree) < 0)) {
            setUpdateError(t("list_courses.error_update_duration"));
            toast.error(t("list_courses.error_update_duration"));
            return;
        }
        if (
            formData.lienZoom &&
            !/^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w- ./?%&=]*)?$/.test(formData.lienZoom)
        ) {
            setUpdateError(t("list_courses.error_update_zoom"));
            toast.error(t("list_courses.error_update_zoom"));
            return;
        }
        try {
            setUpdateLoading(true);
            const data = new FormData();
            data.append('titre', formData.titre);
            data.append('description', formData.description || '');
            data.append('lienZoom', formData.lienZoom || '');
            data.append('duree', formData.duree ? Number(formData.duree) : '');
            if (selectedImage[0] && selectedImage[0].preview !== selectedCourse.imageUrl) {
                data.append('image', selectedImage[0]);
                data.append('deleteOldImage', deleteOldImage);
            }
            if (selectedVideo[0] && selectedVideo[0].preview !== selectedCourse.previewVideoUrl) {
                data.append('previewVideo', selectedVideo[0]);
                data.append('deleteOldVideo', deleteOldVideo);
            }
            const response = await api.patch(`/formation/${selectedCourse._id}`, data, {
                headers: { 'Content-Type': 'multipart/form-data' },
                withCredentials: true,
            });
            if (response.data.status === 'success') {
                toast.success(t("list_courses.success_update"));
                setUpdateModal(false);
                fetchCourses();
            } else {
                setUpdateError(t("list_courses.error_update"));
                toast.error(t("list_courses.error_update"));
            }
        } catch (err) {
            if (err.response.data?.status === 401 || err.response.data?.status === 403) {
                await handleApiError(err, dispatch, navigate);
            } else {
                setUpdateError(err.response?.data?.message || t("list_courses.error_update"));
                toast.error(err.response?.data?.message || t("list_courses.error_update"));
            }
        } finally {
            setUpdateLoading(false);
        }
    };

    const handleUpdateClear = () => {
        setFormData({
            titre: '',
            description: '',
            lienZoom: '',
            duree: '',
        });
        setSelectedImage([]);
        setSelectedVideo([]);
        setDeleteOldImage(false);
        setDeleteOldVideo(false);
        setUpdateError(null);
        toast.info(t("list_courses.info_clear"));
    };

    // Truncate Description
    const truncateDescription = (html, maxLength = 100) => {
        const text = html.replace(/<[^>]+>/g, '');
        return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
    };

    // Pagination
    const paginatedCourses = useMemo(() => {
        const start = (currentPage - 1) * itemsPerPage;
        const end = start + itemsPerPage;
        return filteredCourses.slice(start, end);
    }, [filteredCourses, currentPage]);

    const totalPages = Math.ceil(filteredCourses.length / itemsPerPage);

    return (
        <React.Fragment>
            <style>{customStyles}</style>
            <ToastContainer closeButton={false} limit={1} />
            <DeleteModal
                show={deleteModal}
                onDeleteClick={handleDeleteCourse}
                onCloseClick={() => setDeleteModal(false)}
            />
            <Modal
                isOpen={videoModal}
                toggle={() => setVideoModal(false)}
                centered
                size="lg"
                className="udemy-modal"
            >
                <ModalHeader toggle={() => setVideoModal(false)}>
                    {t('list_courses.video_modal_title', { title: selectedCourse?.titre || "Untitled Course" })}
                </ModalHeader>
                <ModalBody>
                    {selectedCourse?.previewVideoUrl ? (
                        <video controls className="modal-video">
                            <source src={selectedCourse.previewVideoUrl} type="video/mp4" />
                        </video>
                    ) : (
                        <p>{t("list_courses.no_preview_video")}</p>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => setVideoModal(false)}>
                        {t("list_courses.close")}
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal
                isOpen={overviewModal}
                toggle={() => setOverviewModal(false)}
                centered
                size="xl"
                className="udemy-modal"
            >
                <ModalHeader toggle={() => setOverviewModal(false)}>
                    {selectedCourse?.titre}
                </ModalHeader>
                <ModalBody>
                    <div className="course-details">
                        <div className="description-section">
                            <h5>{t("list_courses.description_label")}</h5>
                            <div>{parse(selectedCourse?.description || t("list_courses.no_description"))}</div>
                        </div>
                        <div className="video-section">
                            {selectedCourse?.previewVideoUrl ? (
                                <video controls className="modal-video">
                                    <source src={selectedCourse.previewVideoUrl} type="video/mp4" />
                                </video>
                            ) : (
                                <p>{t("list_courses.no_preview_video")}</p>
                            )}
                            <div className="meta-info">
                                <p><strong>{t("list_courses.duration")}:</strong> {selectedCourse?.duree ? `${selectedCourse.duree} hours` : t("list_courses.no_description")}</p>
                                <p><strong>{t("list_courses.created_at")}:</strong> {selectedCourse?.createdAt ? new Date(selectedCourse.createdAt).toLocaleDateString() : t("list_courses.unknown")}</p>
                                <p><strong>{t("list_courses.inscriptions")}:</strong> {selectedCourse?.inscriptionCount || 0}</p>
                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => setOverviewModal(false)}>
                        {t("list_courses.close")}
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal
                isOpen={updateModal}
                toggle={() => setUpdateModal(false)}
                centered
                size="lg"
                className="udemy-modal"
            >
                <ModalHeader toggle={() => setUpdateModal(false)}>
                    {t('list_courses.update_modal_title', { title: selectedCourse?.titre || "Untitled Course" })}
                </ModalHeader>
                <ModalBody>
                    {updateLoading ? (
                        <div className="text-center py-4">
                            <i className="ri-loader-2-line fs-24 text-primary spin"></i>
                        </div>
                    ) : updateError ? (
                        <Alert color="danger">{updateError}</Alert>
                    ) : (
                        <div>
                            <div className="mb-3">
                                <Label className="form-label" htmlFor="course-title-input">
                                    {t("list_courses.course_title_label")}
                                </Label>
                                <Input
                                    type="text"
                                    className="form-control"
                                    id="course-title-input"
                                    name="titre"
                                    value={formData.titre}
                                    onChange={handleInputChange}
                                    placeholder={t("list_courses.course_title_placeholder")}
                                />
                            </div>
                            <div className="mb-3">
                                <Label className="form-label" htmlFor="course-image">
                                    {t("list_courses.cover_image_label")}
                                </Label>
                                <Dropzone
                                    onDrop={handleImageAccepted}
                                    accept="image/png,image/jpeg,image/webp"
                                    maxFiles={1}
                                >
                                    {({ getRootProps, getInputProps }) => (
                                        <div className="dropzone dz-clickable">
                                            <div className="dz-message needsclick" {...getRootProps()}>
                                                <div className="mb-3">
                                                    <i className="display-4 text-muted ri-upload-cloud-2-fill" />
                                                </div>
                                                <h4>{t("list_courses.drop_image")}</h4>
                                            </div>
                                            <input {...getInputProps()} />
                                        </div>
                                    )}
                                </Dropzone>
                                <ul className="list-unstyled mb-0" id="image-preview">
                                    {selectedImage.map((f, i) => (
                                        <Card
                                            className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                            key={i + "-image"}
                                        >
                                            <div className="p-2">
                                                <Row className="align-items-center">
                                                    <Col className="col-auto">
                                                        <img
                                                            data-dz-thumbnail=""
                                                            height="80"
                                                            className="avatar-sm rounded bg-light"
                                                            alt={f.name}
                                                            src={f.preview}
                                                        />
                                                    </Col>
                                                    <Col>
                                                        <Link to="#" className="text-muted font-weight-bold">
                                                            {f.name}
                                                        </Link>
                                                        <p className="mb-0">
                                                            <strong>{f.formattedSize}</strong>
                                                        </p>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Card>
                                    ))}
                                </ul>
                            </div>
                            <div className="mb-3">
                                <Label className="form-label" htmlFor="course-preview-video">
                                    {t("list_courses.preview_video_label")}
                                </Label>
                                <Dropzone
                                    onDrop={handleVideoAccepted}
                                    accept="video/mp4,video/mov,video/avi"
                                    maxFiles={1}
                                >
                                    {({ getRootProps, getInputProps }) => (
                                        <div className="dropzone dz-clickable">
                                            <div className="dz-message needsclick" {...getRootProps()}>
                                                <div className="mb-3">
                                                    <i className="display-4 text-muted ri-upload-cloud-2-fill" />
                                                </div>
                                                <h4>{t("list_courses.drop_video")}</h4>
                                            </div>
                                            <input {...getInputProps()} />
                                        </div>
                                    )}
                                </Dropzone>
                                <ul className="list-unstyled mb-0" id="video-preview">
                                    {selectedVideo.map((f, i) => (
                                        <Card
                                            className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                            key={i + "-video"}
                                        >
                                            <div className="p-2">
                                                <Row className="align-items-center">
                                                    <Col className="col-auto">
                                                        <video
                                                            height="80"
                                                            className="avatar-sm rounded bg-light"
                                                            controls
                                                        >
                                                            <source src={f.preview} type={f.type} />
                                                        </video>
                                                    </Col>
                                                    <Col>
                                                        <Link to="#" className="text-muted font-weight-bold">
                                                            {f.name}
                                                        </Link>
                                                        <p className="mb-0">
                                                            <strong>{f.formattedSize}</strong>
                                                        </p>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Card>
                                    ))}
                                </ul>
                            </div>
                            <div className="mb-3">
                                <Label className="form-label" htmlFor="course-zoom-link">
                                    {t("list_courses.zoom_link_label")}
                                </Label>
                                <Input
                                    type="text"
                                    className="form-control"
                                    id="course-zoom-link"
                                    name="lienZoom"
                                    value={formData.lienZoom}
                                    onChange={handleInputChange}
                                    placeholder={t("list_courses.zoom_link_placeholder")}
                                />
                            </div>
                            <div className="mb-3">
                                <Label className="form-label" htmlFor="course-duration">
                                    {t("list_courses.duration_label")}
                                </Label>
                                <Input
                                    type="number"
                                    className="form-control"
                                    id="course-duration"
                                    name="duree"
                                    value={formData.duree}
                                    onChange={handleInputChange}
                                    placeholder={t("list_courses.duration_placeholder")}
                                />
                            </div>
                            <div className="mb-3">
                                <Label className="form-label">{t("list_courses.description_label")}</Label>
                                <CKEditor
                                    editor={ClassicEditor}
                                    data={formData.description}
                                    onChange={handleDescriptionChange}
                                />
                            </div>
                        </div>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button color="danger" onClick={handleUpdateClear}>
                        {t("list_courses.clear_button")}
                    </Button>
                    <Button
                        color="primary"
                        onClick={handleUpdateSubmit}
                        disabled={updateLoading}
                    >
                        {updateLoading ? (
                            <i className="ri-loader-2-line spin"></i>
                        ) : (
                            t("list_courses.update_button")
                        )}
                    </Button>
                    <Button color="secondary" onClick={() => setUpdateModal(false)}>
                        {t("list_courses.cancel_button")}
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal
                isOpen={visibilityModal}
                toggle={() => setVisibilityModal(false)}
                centered
                className="udemy-modal"
            >
                <ModalHeader toggle={() => setVisibilityModal(false)}>
                    {t('list_courses.confirm_visibility_toggle')}
                </ModalHeader>
                <ModalBody>
                    <p>
                       Are you sure you want to {visibility === 'on' ? 'hide' : 'show'} this page?
                    </p>
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="primary"
                        onClick={handleToggleVisibility}
                        disabled={visibilityLoading}
                    >
                        {visibilityLoading ? (
                            <i className="ri-loader-2-line spin"></i>
                        ) : (
                            t('list_courses.confirm')
                        )}
                    </Button>
                    <Button
                        color="secondary"
                        onClick={() => setVisibilityModal(false)}
                        disabled={visibilityLoading}
                    >
                        {t('list_courses.cancel_button')}
                    </Button>
                </ModalFooter>
            </Modal>
            <Row className="g-4 mb-3">
                <Col sm="auto">
                    <Link to="/apps-courses-create" className="btn btn-success">
                        <i className="ri-add-line align-bottom me-1"></i> {t("list_courses.add_new_course")}
                    </Link>
                </Col>
                <Col sm="auto">
                    <Button
                        color={visibility === 'on' ? 'primary' : 'secondary'}
                        onClick={() => setVisibilityModal(true)}
                        className="action-btn"
                    >
                        <FeatherIcon
                            icon={visibility === 'on' ? 'eye' : 'eye-off'}
                            className="icon-sm me-1"
                        />
                        {t('list_courses.toggle_visibility')} ({visibility})
                    </Button>
                </Col>
                <Col sm={6} className="ms-auto" style={{ width: '60%' }}>
                    <div className="filter-container hstack gap-2 justify-content-sm-end">
                        <div className="search-box position-relative">
                            <Input
                                style={{ paddingLeft: '26px' }}
                                type="text"
                                className="form-control"
                                placeholder={t("list_courses.search_placeholder")}
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                            />
                            <i className="ri-search-line search-icon position-absolute top-50 start-0 translate-middle-y ms-2"></i>
                        </div>
                        <Input
                            type="select"
                            className="form-select"
                            value={`${sortField}-${sortOrder}`}
                            onChange={(e) => {
                                const [field, order] = e.target.value.split('-');
                                setSortField(field);
                                setSortOrder(order);
                            }}
                        >
                            <option value="createdAt-desc">{t("list_courses.sort_newest")}</option>
                            <option value="createdAt-asc">{t("list_courses.sort_oldest")}</option>
                            <option value="duree-desc">{t("list_courses.sort_longest")}</option>
                            <option value="duree-asc">{t("list_courses.sort_shortest")}</option>
                            <option value="inscriptionCount-desc">{t("list_courses.sort_most_inscriptions")}</option>
                            <option value="inscriptionCount-asc">{t("list_courses.sort_fewest_inscriptions")}</option>
                        </Input>
                    </div>
                </Col>
            </Row>
            {isLoading ? (
                <div className="text-center py-4">
                    <i className="ri-loader-2-line fs-24 text-primary spin"></i>
                </div>
            ) : error ? (
                <Alert color="danger">{error}</Alert>
            ) : (
                <Row>
                    {paginatedCourses.map((course, index) => (
                        <Col xxl={3} sm={6} key={index}>
                            <Card className="card-height-100">
                                <CardBody>
                                    <div className="d-flex flex-column h-100">
                                        <div className="d-flex">
                                            <div className="flex-grow-1">
                                                <p className="text-muted mb-2">
                                                    {course.createdAt
                                                        ? new Date(course.createdAt).toLocaleDateString()
                                                        : t("list_courses.unknown")}
                                                </p>
                                            </div>
                                            <div className="flex-shrink-0">
                                                <UncontrolledDropdown direction="start">
                                                    <DropdownToggle
                                                        tag="button"
                                                        className="btn btn-link text-muted p-1 mt-n2 py-0 text-decoration-none fs-15 shadow-none action-btn"
                                                    >
                                                        <FeatherIcon icon="more-horizontal" className="icon-sm" />
                                                    </DropdownToggle>
                                                    <DropdownMenu className="dropdown-menu-end">
                                                        <DropdownItem onClick={() => handleOverview(course)}>
                                                            <i className="ri-eye-fill align-bottom me-2 text-muted"></i>
                                                            {t("list_courses.overview")}
                                                        </DropdownItem>
                                                        <DropdownItem onClick={() => handleUpdate(course)}>
                                                            <i className="ri-pencil-fill align-bottom me-2 text-muted"></i>
                                                            {t("list_courses.edit")}
                                                        </DropdownItem>
                                                        <DropdownItem onClick={() => handleDeleteClick(course)}>
                                                            <i className="ri-delete-bin-fill align-bottom me-2 text-muted"></i>
                                                            {t("list_courses.delete")}
                                                        </DropdownItem>
                                                    </DropdownMenu>
                                                </UncontrolledDropdown>
                                            </div>
                                        </div>
                                        <div className="mb-2">
                                            {course.imageUrl ? (
                                                <img
                                                    src={course.imageUrl}
                                                    alt={course.titre}
                                                    className="course-image"
                                                />
                                            ) : (
                                                <div className="course-image bg-light text-center d-flex align-items-center justify-content-center">
                                                    <span className="text-muted">{t("list_courses.no_image")}</span>
                                                </div>
                                            )}
                                        </div>
                                        <div className="flex-grow-1">
                                            <h5 className="mb-1 fs-15 text-wrap">
                                                <Link
                                                    to="#"
                                                    onClick={() => handleOverview(course)}
                                                    className="text-dark"
                                                >
                                                    {course.titre}
                                                </Link>
                                            </h5>
                                            <p className="text-muted text-wrap mb-3 truncate-text">
                                                {parse(truncateDescription(course.description || t("list_courses.no_description")))}
                                            </p>
                                        </div>
                                        <div className="mt-auto">
                                            <div className="d-flex mb-2">
                                                <div className="flex-grow-1">
                                                    <div>{t("list_courses.duration")}</div>
                                                </div>
                                                <div className="flex-shrink-0">
                                                    <div>
                                                        {course.duree
                                                            ? `${course.duree} hours`
                                                            : t("list_courses.no_description")}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="d-flex mb-2">
                                                <div className="flex-grow-1">
                                                    <div>{t("list_courses.inscriptions")}</div>
                                                </div>
                                                <div className="flex-shrink-0">
                                                    <div>{course.inscriptionCount || 0}</div>
                                                </div>
                                            </div>
                                            {course.previewVideoUrl && (
                                                <div className="d-flex mb-2">
                                                    <div className="flex-grow-1">
                                                        <div>{t("list_courses.preview_video")}</div>
                                                    </div>
                                                    <div className="flex-shrink-0">
                            <span
                                className="video-preview"
                                onClick={() => handleVideoPreview(course)}
                            >
                              {t("list_courses.watch_preview")}
                            </span>
                                                    </div>
                                                </div>
                                            )}
                                            <div className="d-flex mb-2">
                                                <div className="flex-grow-1">
                                                    <div>{t("list_courses.zoom_link")}</div>
                                                </div>
                                                <div className="flex-shrink-0">
                                                    {course.lienZoom ? (
                                                        <a
                                                            href={course.lienZoom}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="video-preview"
                                                        >
                                                            {t("list_courses.join_zoom")}
                                                        </a>
                                                    ) : (
                                                        <span className="text-muted">{t("list_courses.no_link")}</span>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="d-flex mb-2">
                                                <Button
                                                    color="primary"
                                                    className="inscription-btn w-100"
                                                    tag={Link}
                                                    to={`/apps-inscriptions/${course._id}`}
                                                >
                                                    {t("list_courses.view_inscriptions")}
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    ))}
                </Row>
            )}
            <Row className="g-0 text-center text-sm-start align-items-center mb-4">
                <Col sm={6}>
                    <div>
                        <p className="mb-sm-0 text-muted">
                            {t('list_courses.showing', {
                                start: (currentPage - 1) * itemsPerPage + 1,
                                end: Math.min(currentPage * itemsPerPage, filteredCourses.length),
                                total: filteredCourses.length
                            })}
                        </p>
                    </div>
                </Col>
                <Col sm={6}>
                    <ul className="pagination pagination-separated justify-content-center justify-content-sm-end mb-sm-0">
                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                            <Link
                                to="#"
                                className="page-link"
                                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                            >
                                {t("list_courses.previous")}
                            </Link>
                        </li>
                        {[...Array(totalPages)].map((_, i) => (
                            <li
                                key={i}
                                className={`page-item ${currentPage === i + 1 ? 'active' : ''}`}
                            >
                                <Link
                                    to="#"
                                    className="page-link"
                                    onClick={() => setCurrentPage(i + 1)}
                                >
                                    {i + 1}
                                </Link>
                            </li>
                        ))}
                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                            <Link
                                to="#"
                                className="page-link"
                                onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                            >
                                {t("list_courses.next")}
                            </Link>
                        </li>
                    </ul>
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default ListCourses;